import React from 'react';
import LoginForm from './LoginForm';
import styles from './LoginPage.module.css';

const LoginPage: React.FC = () => {
  return (
    <div className={styles.loginPage}>
      <div className={styles.background}>
        <div className={styles.overlay}></div>
      </div>
      <div className={styles.content}>
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;
